/* app/js/src/components/graphics/edit/edit-graphics.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
icn-edit-graphics-main {
  -webkit-flex: 1.4;
  -ms-flex: 1.4;
  flex: 1.4;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
icn-edit-graphics-aside {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.icn-show {
  display: flex;
  flex: 1;
}
.icn-hide {
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  color: #7d8fa1;
  font-size: 30px;
  letter-spacing: 0.1px;
}
/*# sourceMappingURL=edit-graphics.component.css.map */
